import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

/*
  只剩等宽这一档需要自托管。正文与标题跟随 ignix v8 收敛到 PingFang SC 系统栈，
  不下载任何字体（原来的 Instrument Sans / Instrument Serif / MiSans 已下线）。

  Geist Mono 留着是因为后台满屏是地址、哈希、交易 ID，等宽在这里有实际功能——
  截断后仍能按列对齐、逐字符比对。自托管才能保证 Mac 与非 Mac 看到同一套数字，
  靠系统 SF Mono 兜底等于两个平台两种字形。
  不走 Google Fonts：国内直连不到，掉链子时会静默回落到系统字体。
  在 globals.css 之前引入，让 @font-face 先于其余样式落地。
*/
import '@fontsource-variable/geist-mono'

import { Toaster } from './components/ui/sonner'
import './globals.css'
import { routeTree } from './routeTree.gen'
import { SessionProvider } from './lib/session'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
})

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootEl = document.getElementById('root')!

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors />
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
)
